import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-labelledby", "data-qa"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", {
    role: "group",
    "aria-labelledby": $options.bannerTitleId,
    "data-qa": `info-banner-id:${$props.slide.bannerId}`
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle($options.imageStyle($props.slide.backgroundImageUrl)),
      class: _normalizeClass(['gfu-announcement-content', {'gfu-announcement-content--no-image': !$props.slide.imageUrl}]),
      "data-qa": "info-banner:BackgroundImage"
    }, [
      ($props.slide.imageUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $props.actionUrl,
            class: "gfu-announcement-content__packshot-wrapper",
            "data-qa": "info-banner:Image"
          }, [
            _createElementVNode("div", {
              style: _normalizeStyle($options.imageStyle($props.slide.imageUrl)),
              class: "gfu-announcement-content__packshot"
            }, null, 4 /* STYLE */)
          ], 8 /* PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        style: _normalizeStyle(`color: ${$props.slide.contentStyle}`),
        class: _normalizeClass(['gfu-announcement-content__description _tac', {'gfu-announcement-content__description--no-image': !$props.slide.imageUrl}])
      }, [
        _createElementVNode("h2", {
          id: $options.bannerTitleId,
          class: "gfu-announcement-content__header"
        }, _toDisplayString($props.slide.header), 9 /* TEXT, PROPS */, _hoisted_3),
        ($options.isJsonContent)
          ? (_openBlock(), _createBlock(_component_content_renderer, {
              key: 0,
              class: "_mt-0",
              content: $props.slide.content
            }, null, 8 /* PROPS */, ["content"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "_mt-0",
              innerHTML: $props.slide.content
            }, null, 8 /* PROPS */, _hoisted_4)),
        ($props.actionUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: $props.actionUrl
            }, [
              _createVNode(_component_base_button, {
                class: "_mt-2",
                theme: "default",
                style: _normalizeStyle($options.buttonStyles($props.slide.contentStyle, $props.slide.actionLabelStyle)),
                "data-qa": "info-banner:CtaButton"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.slide.actionLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["style"])
            ], 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true)
      ], 6 /* CLASS, STYLE */)
    ], 6 /* CLASS, STYLE */)
  ], 8 /* PROPS */, _hoisted_1))
}